import styled from 'styled-components';
import * as colors from '../../common/colorConstants';
import * as breakpoints from '../../common/mediaQueries';
import { Link } from 'react-router-dom';

const phoneActionPanel = '300px';
const tabletActionPanelWidth = '400px';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Questrial', sans-serif;
  width: 52rem;
  color: ${colors.black};
`;

export const Title = styled.h1`
  margin-bottom: 2rem;
  font-family: 'Questrial', sans-serif;
  font-size: 4rem;
  font-weight: 500;
  letter-spacing: 0.1rem;
  text-align: center;
`;

export const SubTitle = styled.p`
  margin: 0 3rem 6rem 3rem;
  font-size: 2.3rem;
  font-weight: 500;
  line-height: 2.6rem;
  letter-spacing: 0.03rem;
  text-align: center;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    font-size: 2rem;
    width: ${tabletActionPanelWidth};
  }

  @media screen and (max-width: ${breakpoints.maxMobile}) {
    font-size: 1.8rem;
    color: ${colors.darkGray9};
    width: ${phoneActionPanel};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  padding: 0 1rem;
  margin-bottom: 4rem;
  justify-content: center;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    width: ${tabletActionPanelWidth};
  }

  @media screen and (max-width: ${breakpoints.maxMobile}) {
    width: ${phoneActionPanel};
  }
`;

export const Button = styled.button`
  background-color: ${colors.white};
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 1.5rem;
  font-size: 2rem;
  font-weight: bold;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s ease, border-color 0.3s ease;

  &:hover {
    background-color: #faf9f9;
  }

  &:focus {
    border-color: ${colors.black};
  }

  // Ensure that the Circle stays on the left side of the button
  & > div {
    position: absolute;
    left: 1rem;
  }
`;

export const Circle = styled.div`
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 50%;
  border: 1px solid ${colors.black};
  background-color: ${(props) => (props.selected ? colors.black : colors.white)};
  margin-left: 1rem;
  position: relative;

  // Add custom check mark lines if selected
  &::after {
    content: '';
    display: ${(props) => (props.selected ? 'block' : 'none')};
    position: absolute;
    top: 0.4rem;
    left: 0.9rem;
    width: 0.6rem;
    height: 1.2rem;
    border-right: 1px solid ${colors.white};
    border-bottom: 1px solid ${colors.white};
    transform: rotate(45deg);
  }
`;

export const ContinueButton = styled.button`
  width: 150px;
  height: 50px;
  padding: 1rem;
  background-color: ${colors.electricBlue};
  color: ${colors.white};
  border: none;
  border-radius: 50px;
  font-size: 2rem;
  cursor: pointer;

  &:hover {
    background-color: ${colors.royalBlue};
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    width: ${tabletActionPanelWidth};
  }

  @media screen and (max-width: ${breakpoints.maxMobile}) {
    width: ${phoneActionPanel};
  }
`;

export const Navigation = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 3rem 6rem;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    width: ${tabletActionPanelWidth};
  }

  @media screen and (max-width: ${breakpoints.maxMobile}) {
    width: ${phoneActionPanel};
  }
`;

export const NavigationLink = styled(Link)`
  font-size: 1.8rem;
  color: ${colors.electricBlue};
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &::before {
    content: '←';
    font-size: 1.8rem;
    color: ${colors.electricBlue};
  }

  &:hover {
    text-decoration: underline;
  }
`;

export const EmailText = styled.div`
  color: ${colors.electricBlue};
  margin-bottom: 1rem;
`;
